module.exports = "<p>\r\n  password-recovery works!\r\n</p>\r\n"